import { ReactNode } from 'react';
import Link, { LinkProps } from 'next/link';

import { isDev } from '@restworld/utils-common';

import { Link as CustomLink, LinkProps as CustomLinkProps } from '../../design-system/link';

export const V2Link = ({ href, children, noV2Prefix, ...rest }: V2LinkProps) => {
  const newHref = noV2Prefix
    ? href
    : typeof href === 'string'
    ? `/v2${href}`
    : { ...href, pathname: `/v2${href.pathname}` };

  return (
    <Link href={isDev ? href : newHref} {...rest}>
      {children}
    </Link>
  );
};
export default V2Link;

export const V2CustomLink = ({ href, children, ref, ...rest }: CustomLinkProps) => {
  const newHref = `/v2${href}`;

  return (
    <CustomLink href={isDev ? href : newHref} {...rest}>
      {children}
    </CustomLink>
  );
};

interface V2LinkProps extends LinkProps {
  children: ReactNode;
  noV2Prefix?: boolean;
  className?: string;
}
